<template>
    <div class="quotation-format-box-1" ref="printQuotationDom">
        <div class="title-part">
            <span class="title-span" tkey="報價單">{{i18n.tkey("lang_quotation")}}</span>
        </div>

        <div class="divider-part" style="margin-bottom: 30px">

        </div>

        <div class="between-flex-box" style="margin-bottom: 15px">
            <div>
                <ul>
                    <li>
                        <span class="bigger-font">{{record.Name}}</span>
                    </li>

                    <li>
                        <span class="main-font">{{record.Address}}</span>
                    </li>

                    <li class="normal-flex-div main-font">
                        <div class="short-label">
                            <span tkey="電話">{{i18n.tkey("lang_tel_text")}}</span>
                        </div>

                        <div>
                            <span>:{{record.Telephone}}</span>
                        </div>
                    </li>

                    <li class="normal-flex-div main-font">
                        <div class="short-label">
                            <span tkey="電郵">{{i18n.tkey("lang_email_text")}}</span>
                        </div>

                        <div>
                            <span>:{{record.Email}}</span>
                        </div>
                    </li>

                    <li class="normal-flex-div main-font">
                        <div class="short-label">
                            <span>To</span>
                        </div>

                        <div>
                            <div>
                                :{{record.Address}}
                            </div>

                            <div>
                                &nbsp;{{record.ShipmentAddress}}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="fill-background-box">
                <ul>
                    <li class="normal-flex-div main-font">
                        <div class="normal-label">
                            <span tkey="單號碼">{{i18n.tkey("lang_order_number_text")}}</span>
                        </div>

                        <div>
                            <span>:{{record.QuotationRef}}</span>
                        </div>
                    </li>

                    <li class="normal-flex-div main-font">
                        <div class="normal-label">
                            <span tkey="單日期">{{i18n.tkey("lang_order_date_text")}}</span>
                        </div>

                        <div>
                            <span>:{{record.OrderDate}}</span>
                        </div>
                    </li>

                    <li class="normal-flex-div main-font">
                        <div class="normal-label">
                            <span tkey="銷售人員">{{i18n.tkey("lang_sale_man")}}</span>
                        </div>

                        <div>
                            <span>:{{record.Salesman}}</span>
                        </div>
                    </li>

                    <li class="normal-flex-div main-font">
                        <div class="normal-label">
                            <span tkey="付款條款">{{i18n.tkey("lang_payment_terms")}}</span>
                        </div>

                        <div>
                            <span>:{{}}</span>
                        </div>
                    </li>
                </ul>
            </div>

        </div>

        <div class="divider-part">

        </div>

        <div style="margin-top: 15px">
<!--            <el-table :data="itemList" style="width: 100%">-->
<!--                <el-table-column prop="ProductName" :label="i18n.tkey('lang_product_name')" width="200" />-->
<!--                <el-table-column prop="Description" :label="i18n.tkey('lang_product_des')" width="230" />-->
<!--                <el-table-column prop="TTLQTY" :label="i18n.tkey('lang_qty')" />-->
<!--                <el-table-column prop="Unit" :label="i18n.tkey('lang_product_unit')" />-->
<!--                <el-table-column prop="Cost" :label="i18n.tkey('lang_unit_price')" />-->
<!--                <el-table-column prop="Curr" :label="i18n.tkey('lang_curr')" />-->
<!--                <el-table-column prop="SubTotal" :label="i18n.tkey('lang_total')" />-->
<!--            </el-table>-->

            <table style="width: 100%; border-collapse: collapse;">
                <thead>
                    <tr class="main-font">
                        <td style="width: 200px">{{ i18n.tkey('lang_product_name') }}</td>
                        <td style="width: 230px">{{ i18n.tkey('lang_product_des') }}</td>
                        <td>{{ i18n.tkey('lang_qty') }}</td>
                        <td>{{ i18n.tkey('lang_product_unit') }}</td>
                        <td>{{ i18n.tkey('lang_unit_price') }}</td>
                        <td>{{ i18n.tkey('lang_curr') }}</td>
                        <td>{{ i18n.tkey('lang_total') }}</td>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="(v, i) in itemList" :key="v.id" class="data-li">
                        <td>
                            <span>{{getProductName(v)}}</span>
                        </td>

                        <td>
                            <span>{{getDescription(v)}}</span>
                        </td>

                        <td>
                            <span>{{myUtil.toDecimal2(v.TTLQty)}}</span>
                        </td>

                        <td>
                            <span>{{v.Unit}}</span>
                        </td>

                        <td>
                            <span>{{myUtil.toDecimal2(v.Cost)}}</span>
                        </td>

                        <td>
                            <span>{{v.Curr}}</span>
                        </td>

                        <td>
                            <span>{{myUtil.toDecimal2(v.SubTotal)}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="order-total-part" style="margin-top: 20px;">
            <div class="order-total-content">
                <div>
                    <span tkey="總計">{{i18n.tkey("lang_total_text")}}:</span>
                </div>

                <div>
                    <span>{{record.CurrInOrder}}</span>
                </div>

                <div>
                    <span>{{myUtil.toDecimal2(record.TotalSum)}}</span>
                </div>
            </div>

        </div>

        <div class="between-flex-box" style="margin-top: 25px; align-items: unset; margin-bottom: 30px;">
            <div class="signature-area-1">
                <div>
                    <span class="main-font" tkey="確認">{{i18n.tkey("lang_confirm_text")}}</span>
                </div>

                <div>
                    <span>{{companyObj.CompanyName}}</span>
                </div>

                <div class="company-sign" style="margin-top: 100px">
                    <span tkey="公司蓋章及簽署">{{i18n.tkey("lang_Company_seal_signature")}}</span>
                </div>

                <div class="seal-area" style="margin-top: 50px">
                    <span>ORIGINAL</span>
                </div>
            </div>

            <div class="signature-area-2">
                <span class="main-font" tkey="備註">{{i18n.tkey("lang_notes")}}:</span>
            </div>
        </div>

    </div>
</template>

<script setup>
    import {inject, onBeforeMount, onMounted, ref, toRef} from "vue";
    import myUtil from "@/util/util";
    import html2canvas from "html2canvas";
    import {useUserinfo} from "@/stores/userinfo";

    const props = defineProps(["record", "itemList", "clientObj", "companyObj"])
    const emits = defineEmits(["print-complete"])

    const i18n = inject("i18n")
    const userInfoRef = toRef(useUserinfo())

    const printQuotationDom = ref(null)

    async function screenShot(){
        html2canvas(printQuotationDom.value,{timeout: 250})
            .then(canvas => { //scala默认1 控制字体线条粗细
                // var context = canvas.getContext("2d")
                // context.drawImage(canvas, 0, 0, 425, 275)
                // var data = context.getImageData(0, 0, 425, 275)
                // canvas.width = 425
                // canvas.height = 275
                // context.putImageData(data, 0, 0)
                // context.drawImage(canvas, 0, 0, 425, 275)
                // value.memberworkImgFile = canvas.toDataURL("image/jpeg", 0.8)
                // box.remove()
                // update(value)

                // const imgBase64 = canvas.toDataURL("image/jpeg")
                const imgBase64 = canvas.toDataURL()

                emits("print-complete", imgBase64)

            });
    }

    function getProductName(obj){
        let productname = obj.ProductName

        if (null != obj.ProductNameCN){
            if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
                productname = obj.ProductNameCN
            }
        }

        return productname
    }

    function getDescription(obj){
        let description = obj.Description

        if (null != obj.Description2){
            if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
                description = obj.Description2
            }
        }

        return description
    }

    onBeforeMount(() => {

    })

    onMounted(() => {
        screenShot()
    })

</script>

<style scoped>
    .quotation-format-box-1 {
        width: 795px;
        position: relative;
        background: #ffffff;
        font-size: 12px;
        padding: 20px;
        box-sizing: border-box;
        text-align: left;
        line-height: 2;
    }

    .quotation-format-box-1 ul {
        padding-left: 0;
        list-style: none;
    }

    .quotation-format-box-1 .between-flex-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .divider-part {
        width: 100%;
        border-bottom: 5px #46b5bc solid;
    }

    .title-part {
        margin-bottom: 35px;
    }

    .title-span {
        font-size: 30px;
        color: #46b5bc;
    }

    .fill-background-box {
        background: #efefef;
        width: 300px;
        padding-left: 15px;
        box-sizing: border-box;
    }

    .bigger-font {
        font-size: 18px;
    }

    .main-font {
        font-size: 14px;
    }

    .normal-flex-div {
        display: flex;
    }

    .short-label {
        width: 50px;
    }

    .normal-label {
        width: 85px;
    }

    .data-li {
        box-sizing: border-box;
        border-bottom: 2px #c0c0c0 solid;
        line-height: 2.5;
    }

    .order-total-part {
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .order-total-part .order-total-content {
        width: 200px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 5px;
        border-bottom: 4px #464646 double;
    }

    .signature-area-1 {
        width: 250px;
    }

    .signature-area-1 .company-sign {
        border-top: 1px #464646 solid;
    }

    .signature-area-1 .seal-area {
        font-size: 16px;
        border: 1px #464646 solid;
        padding: 5px;
        box-sizing: border-box;
        text-align: center;
    }

    .signature-area-2 {
        width: 350px;
    }

</style>